import { reduxBatch } from '@manaflair/redux-batch';
import { createStore, applyMiddleware, compose, Store } from 'redux';
import createSagaMiddleware, { END } from 'redux-saga';
import { all } from 'redux-saga/effects';

import * as sagas from '@sagas';

import rootReducer from './root/root.reducer';

type EnhancedStore = Store & {
  close?: () => void;
};

function* rootSagas() {
  yield all(sagas);
}

const composeEnhancers = window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const configureStore = (initialState = {}) => {
  const sagaMiddleware = createSagaMiddleware();

  const store: EnhancedStore = createStore(
    rootReducer,
    initialState,
    composeEnhancers(reduxBatch, applyMiddleware(sagaMiddleware), reduxBatch)
  );

  sagaMiddleware.run(rootSagas);
  store.close = () => store.dispatch(END);

  return store;
};

const store = configureStore();

export default store;
